import React, { memo, useEffect } from 'react';

const TiktokPixel = props => {
  const { category, currency, productId, productName, productPrice } = props;
  useEffect(() => {
    if (window?.ttq !== undefined) {
      let productCategory = category;
      if (category === 'Eyeglasses') {
        productCategory = 'eye';
      }
      if (category === 'Sunglasses') {
        productCategory = 'sun';
      }
      if (category === 'Contact Lens') {
        productCategory = 'contact';
      }
      if (category === 'Accessories') {
        productCategory = 'Accessories';
      }

      window.ttq.track('ViewContent', {
        content_type: 'product',
        content_id: productId,
        content_name: productName,
        content_category: productCategory,
        currency,
        value: productPrice,
      });
    }
  }, [category, currency, productId, productName, productPrice]);

  return <div>{null}</div>;
};

export default memo(TiktokPixel);
